module.exports = function (app) {

    require("./forgot-password/step1")(app);
    require("./forgot-password/step2")(app);
    require("./forgot-password/step3")(app);
    require("./forgot-password/accountRecovery.step2")(app);
    require("./forgot-password/accountRecovery.step3")(app);
    require("./forgot-password/accountRecovery.step4")(app);
    require("./forgot-password/accountRecovery.step4.verify")(app);

    app.controller('pages.forgotPassword', ["$state", "$scope", "session", "coremetrics", "userService", function ($state, $scope, session, coremetrics, userService) {

        var appConfig = (session.data && session.data.appConfig && session.data.appConfig.FORGOT) ? session.data.appConfig.FORGOT : {};
        $scope.isAccountRecoveryActive = true;
        //(appConfig && appConfig.ACCOUNT_RECOVERY && appConfig.ACCOUNT_RECOVERY.booleanValue === true) ? true : false;

        if ($scope.isAccountRecoveryActive) {
            $scope.headings = "Recover Online Access";
            $scope.sidebar = {
                heading: '<span data-teamsite="RECOVERY_LEFTNAV_HEADLINE"></span>',
                description: '<span data-teamsite="RECOVERY_LEFTNAV_HEADLINE_DESC"></span>'
            };
        } else {
            $scope.headings = "Forgot Username or Password";
            $scope.sidebar = {
                heading: "Retrieve username or reset password",
                description: "We’ll confirm that the information you enter here matches our records. Then we’ll send you an email with your username or a temporary password."
            };
        }

        $scope.payload = "";
        $scope.serviceData = {};
        $scope.previousState = $state.params.previousState || null;
        $scope.previousStateParams = $state.params.previousStateParams || {};
        $scope.chevron = {};
        $scope.hideStepIconClass = "hide-step2-icon";

        $scope.goto = function (step, isRecoveryFlow, params) {
            var state = setChevronSelectedSate(step, isRecoveryFlow, params);
            $state.go(state, params);
        };

        $scope.updateChevron = function (selectedStep, isRecoveryFlow, selection) {
            var steps = [];
            $scope.hideStepIconClass = (($scope.isAccountRecoveryActive && selectedStep === 1) ? "hide-step2-icon" : "");

            if ($scope.isAccountRecoveryActive && selectedStep === 1) {
                // If account recovery flow is enabled through appConfig and the selected step is step #1.
                steps = [
                    {label: "Identification", state: "forgotPassword.step1"},
                    {label: '', state: ""}
                ];
            } else if ($scope.isAccountRecoveryActive && isRecoveryFlow) {
                // If account recovery flow is enabled through appConfig and the selected step is for the new recovery flow.
                steps = [
                    {label: "Identification", state: "forgotPassword.step1", validSteps: []},
                    {label: "Retrieve Username", state: "forgotPassword.recoveryStep2", validSteps: [1]},
                    {label: "Verification", state: "forgotPassword.recoveryStep3", validSteps: [1, 2]},
                    {label: "Update Password", state: "forgotPassword.recoveryStep4", validSteps: [1]}
                ];
            } else {
                // If account recovery flow is not enabled or the selected step is not part of the new recovery flow.
                steps = [
                    {label: "Personal information", state: "forgotPassword.step1"},
                    {label: "Security question", state: "forgotPassword.step2"},
                    {label: "Select what you need", state: "forgotPassword.step3"}
                ];
            }
            // Set the chevron's steps and update the chevron's selected state.
            $scope.myChevron = {steps: steps};
            setChevronSelectedSate(selectedStep, isRecoveryFlow);
        };
        $scope.updateChevron(1, false);

        function setChevronSelectedSate(step, isRecoveryFlow, params) {
            var state = (isRecoveryFlow ? "forgotPassword.recoveryStep" : "forgotPassword.step") + step;
            $scope.myChevron.state = state;
            $scope.myChevron.step = step;
            $scope.myChevron.parameters = params;
            return state;
        }

    }]);
    return [
        {
            state: "forgotPassword",
            url: "/forgot-password",
            params: {previousState: '', previousStateParams: {}},
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'FULL_MAINTENANCE',
            views: {
                'body@': {
                    template: require('./forgot-password.html'),
                    controller: "pages.forgotPassword"
                },
                "content@forgotPassword": {
                    template: require('./forgot-password/step1.html'),
                    controller: "pages.forgotPassword.step1"
                }
            }
        },
        {
            state: 'forgotPassword.step1',
            url: '^/forgot-password/step1',
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP1',
            isWCAGCompliant: true,
            params: {error: ''},
            views: {
                "content@forgotPassword": {
                    template: require('./forgot-password/step1.html'),
                    controller: "pages.forgotPassword.step1"
                }
            }
        },
        {
            state: 'forgotPassword.step2',
            url: '^/forgot-password/step2',
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP2',
            isWCAGCompliant: true,
            views: {
                "content@forgotPassword": {
                    template: require('./forgot-password/step2.html'),
                    controller: "pages.forgotPassword.step2"
                }
            }
        },
        {
            state: 'forgotPassword.step3',
            url: '^/forgot-password/step3',
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'FORGOT_PASSWORD_STEP3',
            isWCAGCompliant: true,
            views: {
                "content@forgotPassword": {
                    template: require('./forgot-password/step3.html'),
                    controller: "pages.forgotPassword.step3"
                }
            }
        },
        {
            state: 'forgotPassword.recoveryStep2',
            url: '^/forgot-password/recovery/step2',
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP2',
            params: {user: ''},
            views: {
                "content@forgotPassword": {
                    template: require('./forgot-password/accountRecovery.step2.html'),
                    controller: "pages.forgotPassword.accountRecovery.step2"
                }
            }
        },
        {
            state: 'forgotPassword.recoveryStep3',
            url: '^/forgot-password/recovery/step3',
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP3',
            params: {user: ''},
            views: {
                "content@forgotPassword": {
                    template: require('./forgot-password/accountRecovery.step3.html'),
                    controller: "pages.forgotPassword.accountRecovery.step3"
                }
            },
            resolve: {
                phoneNumbers: function ($stateParams, userService) {
                    if ($stateParams.user) {
                        return userService.getMaskedUserPhone($stateParams.user.userToken, $stateParams.user.userType);
                    }
                    return false;
                }
            }
        },
        {
            state: 'forgotPassword.recoveryStep4',
            url: '^/forgot-password/recovery/step4',
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP4',
            params: {user: ''},
            views: {
                "content@forgotPassword": {
                    template: require('./forgot-password/accountRecovery.step4.html'),
                    controller: "pages.forgotPassword.accountRecovery.step4"
                }
            }
        },
        {
            state: 'forgotPassword.recoveryStep4.verify',
            url: '^/forgot-password/recovery/step4/:userToken/:verificationCode',
            appConfigMaintenanceApp: 'FORGOT',
            appConfigMaintenanceKey: 'ACCOUNT_RECOVERY_STEP4',
            params: {user: ''},
            views: {
                "content@forgotPassword": {
                    template: '<article></article>',
                    controller: "pages.forgotPassword.accountRecovery.step4.verify"
                }
            },
            resolve: {
                verifyCode: function ($stateParams, userService) {
                    return userService.verifyCode($stateParams.userToken, $stateParams.verificationCode);
                }
            }
        }
    ];
};